import { FC } from 'react'
import { Loader } from '@progress/kendo-react-indicators'
import {
  useAppSelector
} from '../../stores'

import './Loading.css'

export const Loading: FC = () => {
  const isLoading = useAppSelector((state) => state.common.isLoading)

  if ((!isLoading)) {
    return null
  } else if (isLoading) {
    // 画面に留まるローディング
    return (
      <div className='loading-background'>
        <Loader size="large" type='pulsing' className="loading-icon"/>
        <span className='loading-text'>実行中...</span>
      </div>
    )
  } else {
    return null
  }
}
